module.exports = " <div class=vc-toast :style=\"{'z-index': zIndex}\" :class=\"{'vc-toast-center': center}\" transition=vc-toast> <slot> <icon v-if=icon :value=icon :size=36></icon> <div class=vc-toast-text>{{text}}</div> </slot> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/toast.vue
 ** module id = 479
 ** module chunks = 1
 **/